export default __webpack_public_path__ + "20f4b36.png";